<script>
  import { updateSubs, updateComponent } from "./scripts/pages.js";
  import {
    pageToLoad,
    pageStack,
    user,
    enableBackButton,
    appMode,
    activeWorkshop,
  } from "./scripts/stores.js";
  import { fly } from "svelte/transition";
  import { populateLessonsAndModules } from "./scripts/lessons.js";

  enableBackButton.set(true);

  $: console.log($pageStack);

  $: console.log($user);

  let ud;

  // needed this dependency chain below in the reactive declarations, because otherwise changes in $appMode weren't triggering

  $: ud = updateComponent($pageToLoad);

  $: ud.modeChange && updateSubs($user.loggedIn, $appMode);

  $: $activeWorkshop.modules &&
    populateLessonsAndModules($activeWorkshop.modules);

  // when activeWorkshop changes, call populateLessonsAndWorkshops

  $: console.log(ud);

  pageToLoad.set("home");
</script>

<main>
  {#key ud.curComponent}
    <div
      class="slider-component-trans"
      in:fly={ud.transition.in}
      out:fly={ud.transition.out}
    >
      <svelte:component this={ud.curComponent} />
    </div>
  {/key}
</main>

<style>
  main {
    display: grid;
    z-index: 1;
    height: 100%;
  }

  .slider-component-trans {
    grid-column: 1/2;
    grid-row: 1/2;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>
